import { Engine, determineEngine } from 'shared/engine-dynamic/engine';
import { Platfrom, determinePlatform } from 'shared/engine-dynamic/platform';

export {
    Engine,
    Platfrom,
}

export class ChilduppRuntimeService {
    static $serviceName = 'childuppRuntime';

    constructor() {
        Object.defineProperties(this, {
            platform: { value: determinePlatform() },
            engine: { value: determineEngine() },
        })
    }

    get isCordova() {
        return this.engine === Engine.CORDOVA;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/childupp-runtime.service.js